import Vue from 'vue'
import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)

Vue.filter('number', function (value, decimals, prefix, sufix) {
    if ( (!value || value == 'false') && value !== 0) return 'N/A'

    if (!decimals) decimals = 2;

    if(typeof(value) != "number"){
      value = value.toString().match(new RegExp("^-?\\d+(?:\\.\\d{0," + decimals + "})?"))[0];
    }else{
      value = +value.toFixed(decimals);
    }

    if (prefix) value = prefix + value;

    if (sufix) value = value + sufix;

    return value
})

Vue.filter('numberNA', function (value, decimals, prefix, sufix) {
    if ( (!value || value == 'false' || value == 'N/A') && value !== 0) return 'N/A'

    if (!decimals) decimals = 2;

    if(typeof(value) != "number"){
      value = parseFloat(value);
      value = +value.toFixed(decimals);
    }

    if (prefix) value = prefix + value;

    if (sufix) value = value + sufix;

    return value
})

Vue.filter('articleDate', function (value) {
    if (!value) return ''

    if (value.toString().indexOf('-') > -1){
       value = value.toString().replace(/-/g,"\/")
    }
    var date = new Date(value)

    return date.toLocaleDateString('en-US', { month: "short", day: "numeric", year: "numeric" })
})

Vue.filter('longMonthDate', function (value) {
    if (!value) return ''

    if (value.toString().indexOf('-') > -1){
       value = value.toString().replace(/-/g,"\/")
    }
    var date = new Date(value)

    return date.toLocaleDateString('en-US', { month: "long", day: "numeric", year: "numeric" })
})

Vue.filter('reallyShortDate', function (value) {
    if (!value) return ''

    if (value.toString().indexOf('-') > -1){
       value = value.toString().replace(/-/g,"\/")
    }

    var date = new Date(value)
    var formattedDate = (((date.getMonth() + 1) < 10) ? '0' : '') + (date.getMonth() + 1) + '/' + ((date.getDate() < 10) ? '0' : '') + date.getDate()

    return formattedDate
})


Vue.filter('capitalizeAll', function (value) {
    if (!value) return ''

    return value.replace(/\b\w/g, function (l) { return l.toUpperCase() })
})

Vue.filter('shortText', function (value, max) {
    if (!value) return ''

    if (!max) {
        max = 190
    }

    if (value.length > max) {
        return value.substring(0,max) + '...'
    }else{
        return value
    }

})

